export default __webpack_public_path__ + "static/media/nic_logo.ce55fef5.svg";